import { render, staticRenderFns } from "./JRB.vue?vue&type=template&id=ef2e02aa"
import script from "./JRB.vue?vue&type=script&lang=js"
export * from "./JRB.vue?vue&type=script&lang=js"
import style0 from "./JRB.vue?vue&type=style&index=0&id=ef2e02aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports